import React from 'react';

export interface NarrowPageProps {
  /**
   * Width of the page.
   *
   * This is a hack to allow resizing the page. Chrome will scale the page so that this width fits across the printed page
   * Probably just leave this at it's default (21cm: a4)
   */
  pageWidth?: string;
}

/**
 * Many pages (eg reports) should not span the entire width of the screen.
 * This component puts a "background" behind the page content, and constrains
 * the content to a max width.
 *
 * It also enforces the minimum height so that any footers are placed at the bottom
 * of the screen even if the content is shorter.
 */
export const NarrowPage: React.FC<NarrowPageProps> = ({ children, pageWidth = '21cm' }) => {
  return (
    <div className="bg-birch-screen flex-grow-1 d-flex flex-column align-items-center">
      <div
        className="d-flex flex-column bg-light-screen shadow-massive flex-grow-1"
        style={{ width: `min(100%, ${pageWidth})` }}
      >
        {children}
      </div>
    </div>
  );
};
